import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DsconfigService, RestConnService, UtilsService } from '@services/services.module';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {

  private list_employees: object;
  private employeeData: object;
  private journeysEmployee: object;
  private categoriesEmployee: object;
  private employee: object;
  private cost_Center: object;
  private divisions: object;
  private journey: object;
  private offices: object;
  private profiles: object;
  private categories: object;
  private calendars: object;
  private groups_division: object;
  private responsable: object;
  private employetype: object;
  private reactivateEmploye: object;

  constructor(
    private dsConfig: DsconfigService,
    private _res: RestConnService,
    public translate: TranslateService,
    public utilsService: UtilsService,
  ) {
    this.list_employees = {
      'list_employees': dsConfig.getUrlBase() + '/ess/v1/employee/all'
    };
    this.cost_Center = {
      'cost_Center': dsConfig.getUrlBase() + '/ess/v1/costCenter/all'
    };
    this.divisions = {
      'divisions': dsConfig.getUrlBase() + '/ess/v1/division/active'
    };
    this.groups_division = {
      'groups_division': dsConfig.getUrlBase() + '/ess/v1/group/all'
    };
    this.journey = {
      'journey': dsConfig.getUrlBase() + '/ess/v1/journey/all'
    };
    this.offices = {
      'offices': dsConfig.getUrlBase() + '/ess/v1/office/all'
    };
    this.profiles = {
      'profiles': dsConfig.getUrlBase() + '/ess/v1/profile/all'
    };
    this.categories = {
      'categories': dsConfig.getUrlBase() + '/ess/v1/category/all'
    };
    this.calendars = {
      'calendars': dsConfig.getUrlBase() + '/ess/v1/calendar/all'
    };
    this.responsable = {
      'responsable': dsConfig.getUrlBase() + '/ess/v1/employee/responsible'
    };
    this.employeeData = {
      'employeeData': dsConfig.getUrlBase() + '/ess/v1/employee/employee'
    };
    this.journeysEmployee = {
      'journeysEmployee': dsConfig.getUrlBase() + '/ess/v1/employee/has_journeys'
    };
    this.categoriesEmployee = {
      'categoriesEmployee': dsConfig.getUrlBase() + '/ess/v1/employee/has_category'
    };
  }

  addEmployee(data: any): Observable<any> {
    this.employee = {
      'employee': this.dsConfig.getUrlBase() + '/ess/v1/employee'
    };

    this.utilsService.deleteNotNeededDates(data);
    if (data.employeeId !== null) {
      return this._res
        .put('employee', data,
          {
            collection: this.employee
          });
    } else {
      return this._res
        .post('employee', data,
          {
            collection: this.employee
          });
    }
  }

  putExtEmployeType(data: any, employeId): Observable<any> {
    this.employetype = {
      'employetype': this.dsConfig.getUrlBase() + '/ess/v1/employee/' + employeId + '/toExtern'
    };

    this.utilsService.deleteNotNeededDates(data);

    if (data.birthEmployee) {
      data['birthEmployee'] = this.utilsService.formatDateToSendToBackend(data.birthEmployee);
    }

    if (data.dateBirth) {
      data['dateBirth'] = this.utilsService.formatDateToSendToBackend(data.dateBirth);
    }

    return this._res.put('employetype', data,
      {
        collection: this.employetype
      });
  }

  putIntEmployeType(data: any, employeId): Observable<any> {
    this.employetype = {
      'employetype': this.dsConfig.getUrlBase() + '/ess/v1/employee/' + employeId + '/toIntern'
    };

    this.utilsService.deleteNotNeededDates(data);

    if (data.birthEmployee) {
      data['birthEmployee'] = this.utilsService.formatDateToSendToBackend(data.birthEmployee);
    }

    if (data.dateBirth) {
      data['dateBirth'] = this.utilsService.formatDateToSendToBackend(data.dateBirth);
    }

    return this._res.put('employetype', data,
      {
        collection: this.employetype
      });
  }

  getEmployeeData(idEmployee): Observable<any> {
    return this._res.get('employeeData', { employeeId: idEmployee },
      {
        collection: this.employeeData
      }
    );
  }

  getWorkingDayEmployee(idEmployee): Observable<any> {
    return this._res.get('journeysEmployee', { intEmpId: idEmployee },
      {
        collection: this.journeysEmployee
      }
    );
  }

  getCategoryData(idEmployee): Observable<any> {
    return this._res.get('categoriesEmployee', { intEmpId: idEmployee },
      {
        collection: this.categoriesEmployee
      }
    );
  }

  getCostCenter(): Observable<any> {
    return this._res.get('cost_Center', {},
      {
        collection: this.cost_Center
      }
    );
  }

  getDivisions(): Observable<any> {
    return this._res.get('divisions', {},
      {
        collection: this.divisions
      }
    );
  }

  getWorkingDays(): Observable<any> {
    return this._res.get('journey', {},
      {
        collection: this.journey
      }
    );
  }

  getOffices(): Observable<any> {
    return this._res.get('offices', {},
      {
        collection: this.offices
      }
    );
  }

  getProfiles(): Observable<any> {
    return this._res.get('profiles', {},
      {
        collection: this.profiles
      }
    );
  }

  getCategories(): Observable<any> {
    return this._res.get('categories', {},
      {
        collection: this.categories
      }
    );
  }

  getCalendars(): Observable<any> {
    return this._res.get('calendars', {},
      {
        collection: this.calendars
      }
    );
  }

  getDivisionGroups(division): Observable<any> {
    return this._res.get('groups_division', { intDivId: division },
      {
        collection: this.groups_division
      }
    );
  }

  getResponsible(division): Observable<any> {
    return this._res.get('responsable', { intDivId: division },
      {
        collection: this.responsable
      }
    );
  }

  getAllEmployees(): Observable<any> {
    return this._res.get('list_employees', {},
      {
        collection: this.list_employees
      }
    );
  }

  reactiveEmploye(employe: number): Observable<any> {
    this.reactivateEmploye = {
      'reactivateEmploye': this.dsConfig.getUrlBase() + '/ess/v1/employee/endDate?&employeeId=' + employe
    };
    return this._res.put('reactivateEmploye', { employeeId: employe },
      {
        collection: this.reactivateEmploye
      }
    );
  }
}
